import React from "react";

import SectionFigure from "./SectionFigure";

export default function ReactSection(props) {
  return (
    <>
      <section className="section-spacing" id={props.sectionID}>
        <div className="container">
          <h2 className="heading-secondary">{props.sectionHeading}</h2>

          <div className="container-figure">
            <div className="grid grid--2-cols grid--2-rows">
              <SectionFigure
                heading="TextUtils "
                listItem1=" A quick way to analyze your text
                efficiently"
                listItem2="TextUtils is a free character counter tool"
                listItem3="Works in any web browser such as
                Chrome, Safari, etc"
                appURL="https://jayant-text-utils.netlify.app/"
              />
              <SectionFigure
                figGridPlacement="row-2--col-2"
                heading="NewsApe"
                listItem1="Get your daily dose of news for free!"
                listItem2="Interested in news, weather, politics and sports news?"
                listItem3="Then NewsApe is for you!!!"
                appURL="https://newsape.netlify.app/"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
